define([
    "./userPreferencesModule",
    "./monitoringUserPreferencesProperties",
    "./monitoringUserPreferencesService",
    "./planningUserPreferencesProperties",
    "./planningUserPreferencesService",
], function () {
});